var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgD = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "5.25rem",
  height: "5.25rem",
  "data-name": "Group 10",
  viewBox: "0 0 200 240.319"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "D_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h200v240.319H0z",
  "data-name": "Rectangle 19"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 9",
  style: {
    clipPath: "url(#D_svg__a)"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M197.669 113.668 109.025 4.171a11.82 11.82 0 0 0-18.02 0L2.361 113.668a10.106 10.106 0 0 0 0 12.984L91 236.109a11.746 11.746 0 0 0 18.02 0l88.644-109.457a10.206 10.206 0 0 0 0-12.984",
  "data-name": "Path 5"
}))));
export default SvgD;